export default [
  {
    title: "Checklista",
    key: "CHECKLIST",
    visited: true,
    hasError: false,
    fieldKeys: ["name", "hide_for_tenants", "hide_for_non_tenants"],
  },
];
